import Divider from '@mui/material/Divider';
import { REPORT_COLORS } from '../../lobby/constants';

type Props = {
    isCell?: boolean;
};

export const ReportDivider = (props: Props) => {
    const { isCell = false } = props;
    return (
        <Divider
            sx={
                isCell
                    ? {
                            borderWidth: '0.04rem',
                        //   borderColor: '#827256',
                            borderColor: REPORT_COLORS.BORDER,
                      }
                    : {
                            borderWidth: '0.04rem',
                        //   borderWidth: '2px',
                          borderColor: REPORT_COLORS.BORDER,
                      }
            }
        />
    );
};

export const DetailListDivider = () => {
    return (
        <Divider
            sx={{
                borderWidth: '0.03125rem',
                borderColor: `#4d4d4d`,
            }}
        />
    );
};
